import { render } from "./VentasCreditoInteres.vue?vue&type=template&id=1633cf49&scoped=true"
import script from "./VentasCreditoInteres.vue?vue&type=script&lang=js"
export * from "./VentasCreditoInteres.vue?vue&type=script&lang=js"

import "./VentasCreditoInteres.vue?vue&type=style&index=0&id=1633cf49&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1633cf49"]])

export default __exports__